export const BOOKSHELF_REQUEST = 'BOOKSHELF_REQUEST'
export const BOOKSHELF_GET_LIST = 'BOOKSHELF_GET_LIST'
export const BOOKSHELF_GET = 'BOOKSHELF_GET'
export const BOOKSHELF_CREATE = 'BOOKSHELF_CREATE'
export const BOOKSHELF_UPDATE = 'BOOKSHELF_UPDATE'
export const BOOKSHELF_DELETE = 'BOOKSHELF_DELETE'
export const BOOKSHELF_SET_CURRENT = 'BOOKSHELF_SET_CURRENT'
export const BOOKSHELF_SUCCESS = 'BOOKSHELF_SUCCESS'
export const BOOKSHELF_FAILURE = 'BOOKSHELF_FAILURE'
export const BOOKSHELF_BOOK_MOVE_BOOKS = 'BOOKSHELF_BOOK_MOVE_BOOKS'
export const BOOKSHELF_BOOK_DELETE_BOOKS = 'BOOKSHELF_BOOK_DELETE_BOOKS'
export const BOOKSHELF_BOOK_COUNT = 'BOOKSHELF_BOOK_COUNT'
export const BOOKSHELF_BOOK_FILTER = 'BOOKSHELF_BOOK_FILTER'
export const BOOKSHELF_MOVE = 'BOOKSHELF_MOVE'

export const BOOKSHELF_BOOK_REQUEST = 'BOOKSHELF_BOOK_REQUEST'
export const BOOKSHELF_BOOK_GET = 'BOOKSHELF_BOOK_GET'
export const BOOKSHELF_BOOK_GET_LIST = 'BOOKSHELF_BOOK_GET_LIST'
export const BOOKSHELF_BOOK_UPDATE = 'BOOKSHELF_BOOK_UPDATE'
export const BOOKSHELF_BOOK_SUCCESS = 'BOOKSHELF_BOOK_SUCCESS'
export const BOOKSHELF_BOOK_FAILURE = 'BOOKSHELF_BOOK_FAILURE'

export const SELFBOOK_REQUEST = 'SELFBOOK_REQUEST'
export const SELFBOOK_GET = 'SELFBOOK_GET'
export const SELFBOOK_GET_LIST = 'SELFBOOK_GET_LIST'
export const SELFBOOK_CREATE = 'SELFBOOK_CREATE'
export const SELFBOOK_UPDATE = 'SELFBOOK_UPDATE'
export const SELFBOOK_DELETE = 'SELFBOOK_DELETE'
export const SELFBOOK_SUCCESS = 'SELFBOOK_SUCCESS'
export const SELFBOOK_FAILURE = 'SELFBOOK_FAILURE'
export const SELFBOOK_SET_CURRENT = 'SELFBOOK_SET_CURRENT'
export const SELFBOOK_CATEGORIES_GET = 'SELFBOOK_CATEGORIES_GET'

export const SELFBOOK_POPULAR_REQUEST = 'SELFBOOK_POPULAR_REQUEST'
export const SELFBOOK_POPULAR_GET_LIST = 'SELFBOOK_POPULAR_GET_LIST'
export const SELFBOOK_POPULAR_SUCCESS = 'SELFBOOK_POPULAR_SUCCESS'
export const SELFBOOK_POPULAR_FAILURE = 'SELFBOOK_POPULAR_FAILURE'

export const UI_SHOW_SIDEBAR = 'UI_SHOW_SIDEBAR'
export const UI_CLOSE_SIDEBAR = 'UI_CLOSE_SIDEBAR'

export const UI_ENABLE_MOVE_BOOK_MODE = 'UI_ENABLE_MOVE_BOOK_MODE'
export const UI_DISABLE_MOVE_BOOK_MODE = 'UI_DISABLE_MOVE_BOOK_MODE'

export const UI_SELECT_BOOK = 'UI_SELECT_BOOK'
export const UI_UNSELECT_BOOK = 'UI_UNSELECT_BOOK'
export const UI_UNSELECT_ALL_BOOKS = 'UI_UNSELECT_ALL_BOOKS'

export const STORE_MAIN_GET = 'STORE_MAIN_GET'
export const STORE_REQUEST = 'STORE_REQUEST'
export const STORE_SUCCESS = 'STORE_SUCCESS'
export const STORE_FAILURE = 'STORE_FAILURE'
export const STORE_CATEGORIES_GET = 'STORE_CATEGORIES_GET'
export const STORE_CATEGORIES_GET_LIST = 'STORE_CATEGORIES_GET_LIST'
export const STORE_CATEGORIES_GET_ALL = 'STORE_CATEGORIES_GET_ALL'
export const STORE_CATEGORIES_REQUEST = 'STORE_CATEGORIES_REQUEST'
export const STORE_CATEGORIES_SUCCESS = 'STORE_CATEGORIES_SUCCESS'
export const STORE_CATEGORIES_FAILURE = 'STORE_CATEGORIES_FAILURE'
export const STORE_BOOK_REQUEST = 'STORE_BOOK_REQUEST'
export const STORE_BOOK_GET_LIST = 'STORE_BOOK_GET_LIST'
export const STORE_BOOK_GET = 'STORE_BOOK_GET'
export const STORE_BOOK_SUCCESS = 'STORE_BOOK_SUCCESS'
export const STORE_BOOK_FAILURE = 'STORE_BOOK_FAILURE'
export const STORE_CATEGORY_BOOKS_GET_LIST = 'STORE_CATEGORY_BOOKS_GET'
export const STORE_CATEGORY_BOOKS_REQUEST = 'STORE_CATEGORY_BOOKS_REQUEST'
export const STORE_CATEGORY_BOOKS_SUCCESS = 'STORE_CATEGORY_BOOKS_SUCCESS'
export const STORE_CATEGORY_BOOKS_FAILURE = 'STORE_CATEGORY_BOOKS_FAILURE'
export const STORE_ENOTE_GET_LIST = 'STORE_ENOTE_GET_LIST'
export const STORE_ENOTE_REQUEST = 'STORE_ENOTE_REQUEST'
export const STORE_ENOTE_SUCCESS = 'STORE_ENOTE_SUCCESS'
export const STORE_ENOTE_FAILURE = 'STORE_ENOTE_FAILURE'
export const STORE_SEARCH_MAIN = 'STORE_SEARCH_MAIN'
export const STORE_SEARCH_TERM = 'STORE_SERACH_TERM'
export const STORE_SEARCH_REQUEST = 'STORE_SEARCH_REQUEST'
export const STORE_SEARCH_SUCCESS = 'STORE_SEARCH_SUCCESS'
export const STORE_SEARCH_FAILURE = 'STORE_SEARCH_FAILURE'
export const STORE_ANNOUNCEMENT_GET_LIST = 'STORE_ANNOUNCEMENT_GET_LIST'
export const STORE_ANNOUNCEMENT_REQUEST = 'STORE_ANNOUNCEMENT_REQUEST'
export const STORE_ANNOUNCEMENT_SUCCESS = 'STORE_ANNOUNCEMENT_SUCCESS'
export const STORE_ANNOUNCEMENT_FAILURE = 'STORE_ANNOUNCEMENT_FAILURE'
export const STORE_BOOK_REVIEW_GET_LIST = 'STORE_BOOK_REVIEW_GET_LIST'
export const STORE_BOOK_REVIEW_REQUEST = 'STORE_BOOK_REVIEW_REQUEST'
export const STORE_BOOK_REVIEW_SUCCESS = 'STORE_BOOK_REVIEW_SUCCESS'
export const STORE_BOOK_REVIEW_FAILURE = 'STORE_BOOK_REVIEW_FAILURE'
export const STORE_LOADING_STOP = 'STORE_LOADING_STOP'
export const STORE_POPUP = 'STORE_POPUP' // 팝업
export const STORE_POPUP_SUCCESS = 'STORE_POPUP_SUCCESS'
export const STORE_POPUP_FAILURE = 'STORE_POPUP_FAILURE'
export const STORE_EVENT_CATEGORIES_GET = 'STORE_EVENT_CATEGORIES_GET'
export const STORE_EVENT_CATEGORIES_REQUEST = 'STORE_EVENT_CATEGORIES_REQUEST'
export const STORE_EVENT_CATEGORIES_SUCCESS = 'STORE_EVENT_CATEGORIES_SUCCESS'
export const STORE_EVENT_CATEGORIES_FAILURE = 'STORE_EVENT_CATEGORIES_FAILURE'

export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_REFRESH = 'AUTH_REFRESH'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAILURE = 'AUTH_FAILURE'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_CHECK_USERNAME = 'AUTH_CHECK_USERNAME'
export const AUTH_REGISTER = 'AUTH_REGISTER'
export const AUTH_REGISTER_SOCIAL = 'AUTH_REGISTER_SOCIAL'
export const AUTH_CHECK_CRED = 'AUTH_CHECK_CRED'
export const AUTH_SIGNED_URL_GET = 'AUTH_SIGNED_URL_GET'
export const AUTH_FIND_ID = 'AUTH_FIND_ID'
export const AUTH_REQUEST_TEMPORARY_PASSWORD = 'AUTH_REQUEST_TEMPORARY_PASSWORD'
export const AUTH_SEND_EMAIL_VERIFICATION = 'AUTH_SEND_EMAIL_VERIFICATION'
export const AUTH_VERIFY_EMAIL = 'AUTH_VERIFY_EMAIL'
export const AUTH_GET_IMP_INFO = 'AUTH_GET_IMP_INFO'
export const AUTH_REGISTER_UNICOL = 'AUTH_REGISTER_UNICOL'
// 아이엠 포트 정보 가져오기

export const ACCOUNT_GET_INFO = 'ACCOUNT_GET_INFO'
export const ACCOUNT_UPDATE_INFO = 'ACCOUNT_UPDATE_INFO'
export const ACCOUNT_UPLOAD_PROFILE_IMAGE = 'ACCOUNT_UPLOAD_PROFILE_IMAGE'
export const ACCOUNT_REMOVE_PROFILE_IMAGE = 'ACCOUNT_REMOVE_PROFILE_IMAGE'
export const ACCOUNT_UPDATE_PASSWORD = 'ACCOUNT_UPDATE_PASSWORD'
export const ACCOUNT_UPDATE_PASSWORD_MAIL = 'ACCOUNT_UPDATE_PASSWORD_MAIL'
export const ACCOUNT_UPDATE_UNICOL = 'ACCOUNT_UPDATE_UNICOL'
export const ACCOUNT_CLOSE = 'ACCOUNT_CLOSE'
export const ACCOUNT_REQUEST = 'ACCOUNT_REQUEST'
export const ACCOUNT_SUCCESS = 'ACCOUNT_SUCCESS'
export const ACCOUNT_FAILURE = 'ACCOUNT_FAILURE'

export const ACCOUNT_REVIEW_CREATE = 'ACCOUNT_REVIEW_CREATE'
export const ACCOUNT_REVIEW_GET_LIST = 'ACCOUNT_REVIEW_GET_LIST'
export const ACCOUNT_REVIEW_UPDATE = 'ACCOUNT_REVIEW_UPDATE'
export const ACCOUNT_REVIEW_VOTE = 'ACCOUNT_REVIEW_VOTE'
export const ACCOUNT_REVIEW_DELETE = 'ACCOUNT_REVIEW_DELETE'
export const ACCOUNT_REVIEW_REQUEST = 'ACCOUNT_REVIEW_REQUEST'
export const ACCOUNT_REVIEW_SUCCESS = 'ACCOUNT_REVIEW_SUCCESS'
export const ACCOUNT_REVIEW_FAILURE = 'ACCOUNT_REVIEW_FAILURE'

export const ACCOUNT_ORDER_GET_LIST = 'ACCOUNT_ORDER_GET_LIST'
export const ACCOUNT_ORDER_GET = 'ACCOUNT_ORDER_GET'
export const ACCOUNT_ORDER_CANCEL = 'ACCOUNT_ORDER_CANCEL'
export const ACCOUNT_ORDER_REQUEST_RETURN = 'ACCOUNT_ORDER_REQUEST_RETURN'
export const ACCOUNT_ORDER_CANCEL_RETURN = 'ACCOUNT_ORDER_CANCEL_RETURN'
export const ACCOUNT_ORDER_REQUEST = 'ACCOUNT_ORDER_REQUEST'
export const ACCOUNT_ORDER_SUCCESS = 'ACCOUNT_ORDER_SUCCESS'
export const ACCOUNT_ORDER_FAILURE = 'ACCOUNT_ORDER_FAILURE'

export const ACCOUNT_RETURN_GET_LIST = 'ACCOUNT_RETURN_GET_LIST'
export const ACCOUNT_RETURN_REQUEST = 'ACCOUNT_RETURN_REQUEST'
export const ACCOUNT_RETURN_SUCCESS = 'ACCOUNT_RETURN_SUCCESS'
export const ACCOUNT_RETURN_FAILURE = 'ACCOUNT_RETURN_FAILURE'

export const ACCOUNT_ORDER_DELIVERY_DETAIL_GET =
  'ACCOUNT_ORDER_DELIVERY_DETAIL_GET'
export const ACCOUNT_ORDER_DELIVERY_DETAIL_REQUEST =
  'ACCOUNT_ORDER_DELIVERY_DETAIL_REQUEST'
export const ACCOUNT_ORDER_DELIVERY_DETAIL_SUCCESS =
  'ACCOUNT_ORDER_DELIVERY_DETAIL_SUCCESS'
export const ACCOUNT_ORDER_DELIVERY_DETAIL_FAILURE =
  'ACCOUNT_ORDER_DELIVERY_DETAIL_FAILURE'

export const ACCOUNT_DISCOUNT_GET_LIST = 'ACCOUNT_DISCOUNT_GET_LIST' //사용자 보유 할인쿠폰 목록
export const ACCOUNT_DISCOUNT_REQUEST = 'ACCOUNT_DISCOUNT_REQUEST'
export const ACCOUNT_DISCOUNT_SUCCESS = 'ACCOUNT_DISCOUNT_SUCCESS'
export const ACCOUNT_DISCOUNT_FAILURE = 'ACCOUNT_DISCOUNT_FAILURE'

export const CART_GET_LIST = 'CART_GET_LIST'
export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_UPDATE_ITEM = 'CART_UPDATE_ITEM'
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'
export const CART_CREATE_PRE_ORDER = 'CART_CREATE_PRE_ORDER'
export const CART_PRE_ORDER_RESTORE = 'CART_PRE_ORDER_RESTORE'
export const CART_CREATE_ORDER = 'CART_CREATE_ORDER'
export const CART_GET_DEFAULT_ADDRESS = 'CART_GET_DEFAULT_ADDRESS'
export const CART_REQUEST = 'CART_REQUEST'
export const CART_SUCCESS = 'CART_SUCCESS'
export const CART_FAILURE = 'CART_FAILURE'
export const CART_GET_DISCOUNT_LIST = 'CART_GET_DISCOUNT_LIST'

export const FAQ_GET_LIST = 'FAQ_GET_LIST'
export const FAQ_REQUEST = 'FAQ_REQUEST'
export const FAQ_SUCCESS = 'FAQ_SUCCESS'
export const FAQ_FAILURE = 'FAQ_FAILURE'

export const EVENT_GET_LIST = 'EVENT_GET_LIST'
export const EVENT_REQUEST = 'EVENT_REQUEST'
export const EVENT_SUCCESS = 'EVENT_SUCCESS'
export const EVENT_FAILURE = 'EVENT_FAILURE'

// 추가 해외 딜리버리
export const DELIVERY_LIST_GET = 'DELIVERY_LIST_GET'
export const DELIVERY_LIST_SUCCESS = 'DELIVERY_LIST_SUCCESS'
export const DELIVERY_LIST_FAILED = 'DELIVERY_LIST_FAILED'

export const NEWSLETTER_GET_LIST = 'NEWSLETTER_GET_LIST'
export const NEWSLETTER_REQUEST = 'NEWSLETTER_REQUEST'
export const NEWSLETTER_SUCCESS = 'NEWSLETTER_SUCCESS'
export const NEWSLETTER_FAILURE = 'NEWSLETTER_FAILURE'

// COUPON.JS
export const APPLICATION_REQUEST = 'APPLICATION_REQUEST'
export const APPLICATION_SUCCESS = 'APPLICATION_SUCCESS'
export const APPLICATION_FAILURE = 'APPLICATION_FAILURE'
export const APPLICATION_CREATE = 'APPLICATION_CREATE'
export const COUPON_PROVIDER = 'COUPON_PROVIDER'
export const COUPON_PROVIDER_REQUEST = 'COUPON_PROVIDER_REQUEST'
export const COUPON_PROVIDER_SUCCESS = 'COUPON_PROVIDER_SUCCESS'
export const COUPON_PROVIDER_FAILURE = 'COUPON_PROVIDER_FAILURE'
export const COUPON_PROVIDER_BOOKFAIR = 'COUPON_PROVIDER_BOOKFAIR'
export const COUPON_PROVIDER_BOOKFAIR_REQUEST =
  'COUPON_PROVIDER_BOOKFAIR_REQUEST'
export const COUPON_PROVIDER_BOOKFAIR_SUCCESS =
  'COUPON_PROVIDER_BOOKFAIR_SUCCESS'
export const COUPON_PROVIDER_BOOKFAIR_FAILURE =
  'COUPON_PROVIDER_BOOKFAIR_FAILURE'

export const ONE_TOUCH_COUPON = 'ONE_TOUCH_COUPON'

export const MEMBER_TYPE_NORMAL = 'MEMBER_TYPE_NORMAL'
export const MEMBER_TYPE_TEACHER = 'MEMBER_TYPE_TEACHER'

export const PREPARE_TRIAL = 'PREPARE_TRIAL'
export const PROVIDE_TRIAL = 'PROVIDE_TRIAL'
export const PREPARE_BOOKFAIR_TRIAL = 'PREPARE_BOOKFAIR_TRIAL'
export const PROVIDE_BOOKFAIR_TRIAL = 'PROVIDE_BOOKFAIR_TRIAL'

export const TOSS_PAYMENT_CONFIRM = 'TOSS_PAYMENT_CONFIRM'

// bookList.js
// mutations
export const BOOK_LIST_SUCCESS = 'BOOK_LIST_SUCCESS'
export const GENRE_SUCCESS = 'GENRE_SUCCESS'
// actions
export const UNICOL_BOOKS_LIST = 'UNICOL_BOOKS_LIST'
export const EBOOK_ONLY_LIST = 'EBOOK_ONLY_LIST'
export const GENRE_BOOK_LIST = 'GENRE_BOOK_LIST'
export const GENRE_LIST = 'GENRE_LIST'
export const CATEGORY_BOOKS_LIST = 'CATEGORY_BOOKS_LIST'
//--

//search.js
export const SEARCH_LIST_PREVIEW = 'SEARCH_LIST_PREVIEW'

//supplement.js
export const SUPPLEMENT_STATUS = 'SUPPLEMENT_STATUS'
export const SUPPLEMENT_STATUS_SUCCESS = 'SUPPLEMENT_STATUS_SUCCESS'
export const SUPPLEMENT_STATUS_RESET = 'SUPPLEMENT_STATUS_RESET'
export const SUPPLEMENT_FILES = 'SUPPLEMENT_FILES'
export const SUPPLEMENT_FILE_URL = 'SUPPLEMENT_FILE_URL'
export const BOOKSHELF_SUPPLEMENT_DOWNLOAD = 'BOOKSHELF_SUPPLEMENT_DOWNLOAD'

// 이벤트
export const FETCH_EVENT_POINT_RANK = 'FETCH_EVENT_POINT_RANK'
export const FETCH_EVENT_POINT_UNIVERSITY = 'FETCH_EVENT_POINT_UNIVERSITY'
export const SET_RANK_LIST = 'SET_RANK_LIST'
export const SET_USER_UNIV_INFO = 'SET_USER_UNIV_INFO'

// claim 추가
export const CLAIM_CONTENT = 'CLAIM_CONTENT'
export const PREPARE_CLAIM_CODE = 'PREPARE_CLAIM_CODE'
export const CLEAR_CLAIM_CODE = 'CLEAR_CLAIM_CODE'
export const PREPARE_CLAIM_TYPE = 'PREPARE_CLAIM_TYPE'
export const CLEAR_CLAIM_TYPE = 'CLEAR_CLAIM_TYPE'
